import revive_payload_client_4sVQNw7RlN from "/src/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/src/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/src/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/src/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/src/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/src/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/src/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/src/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/src/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/src/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/src/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/src/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import i18n_Ug908EZNww from "/src/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_tMGwffvjBc from "/src/node_modules/@formkit/auto-animate/nuxt/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/src/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_ghbUAjaD3n from "/src/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_Jozdw60ZsE from "/src/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_AUP22rrBAc from "/src/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import _02_refresh_access_token_client_hsGneSmQkb from "/src/plugins/02.refresh-access-token.client.ts";
import _03_auth_1Ew6OcGSPq from "/src/plugins/03.auth.js";
import _04_consent_yTMLdSt1lV from "/src/plugins/04.consent.ts";
import bazaarvoice_client_vOu8OkNkLp from "/src/plugins/bazaarvoice.client.ts";
import datadog_log_client_ahAQeMWFsG from "/src/plugins/datadog-log.client.js";
import datadog_rum_client_enPp5k569L from "/src/plugins/datadog-rum.client.js";
import lru_cache_client_qnDM2Zai7C from "/src/plugins/lru-cache.client.ts";
import scrollTracking_client_qAPH4OjGmt from "/src/plugins/scrollTracking.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  i18n_Ug908EZNww,
  plugin_tMGwffvjBc,
  i18n_yfWm7jX06p,
  plugin_ghbUAjaD3n,
  plugin_Jozdw60ZsE,
  plugin_AUP22rrBAc,
  _02_refresh_access_token_client_hsGneSmQkb,
  _03_auth_1Ew6OcGSPq,
  _04_consent_yTMLdSt1lV,
  bazaarvoice_client_vOu8OkNkLp,
  datadog_log_client_ahAQeMWFsG,
  datadog_rum_client_enPp5k569L,
  lru_cache_client_qnDM2Zai7C,
  scrollTracking_client_qAPH4OjGmt
]